/**
 * Entitlement IDs for feature access control
 * These IDs must match the entitlement records in the database
 */

export const ENTITLEMENT_IDS = {
  WHITE_LABEL: "a030b9c2-daf1-40b0-81a6-d943cd60c49c",
  WAREHOUSE: "bfda57a5-f264-4984-9740-36eeaff99280",
  PURCHASE_ORDER: "9b05cebd-9ffc-4972-a7e5-df263f8a2082",
  AI_IMPORT: "56c21049-e936-4953-a2c6-030f0f858b3e"
};
